<template>
  <!-- TODO: 公众号、小程序、微信客服 -->
  <div id='bd-main'>
    <el-row style="margin-top: 5px; margin-bottom: 5px;">
      <el-col :span="1"><el-button size="mini" @click="refreshData()"><i class="el-icon-refresh"></i>刷新</el-button></el-col>
    </el-row>
    <el-table v-loading="isLoading" :data="visitorsWechat.content" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="nickname" label="访客"></el-table-column>
      <el-table-column prop="client" label="来源渠道"></el-table-column>
      <el-table-column prop="connectionStatus" label="状态">
        <template slot-scope="scope">{{ scope.row.connectionStatus === 'connected' ? '在线' : '离线' }}</template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="最近活跃">
        <template slot-scope="scope">{{ scope.row.updatedAt.substring(5) }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="browseInvite(scope.$index, scope.row)" type="text" size="small" :disabled="isDisabled(scope.row)">
            邀请会话
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="visitorsWechat.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      isLoading: false,
      // status: 'connected',
    }
  },
  computed: {
    ...mapGetters([ 'visitorsWechat' ])
  },
  methods: {
    ...mapActions([ 'getVisitorsWechat' ]),
    //
    isDisabled (record) {
      return record.connectionStatus !== 'connected'
    },
    browseInvite(index, browse) {
      // console.log(index, browse)
      // TODO:
      this.$message.warning('即将上线，敬请期待')
    },
    handleSuccess(response) {
      this.isLoading = false
    },
    handleError(error) {
      this.isLoading = false
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val - 1}`);
      this.isLoading = true
      let payload = { page: val - 1, size: 10, successcb: this.handleSuccess, failedcb: this.handleError }
      this.getVisitorsWechat(payload)
    },
    refreshData() {
      this.isLoading = true
      let payload = { page: 0, size: 10, successcb: this.handleSuccess, failedcb: this.handleError }
      this.getVisitorsWechat(payload)
    }
  },
  created() {
    this.refreshData()
  },

}
</script>

<style scoped>

</style>
